// extracted by mini-css-extract-plugin
export default {"link":"visitParentResourceLink_link__QPP9n","linkDisabled":"visitParentResourceLink_linkDisabled__OS+7+"};